import { lazy } from 'react';
import NotFoundPage from '../views/not_found/not_found.view.js';
import MinimalLayout from '../layouts/MinimalLayout/index.js';
import { Navigate } from 'react-router-dom';

/****Layouts*****/
const AdminOrdersPage = lazy(() => import('../views/admin/AdminOrdersPage.js'));
const PromoCheckPage = lazy(() => import('../views/promo/PromoCheckPage'));
const HomePage = lazy(() => import('../views/home/HomePage.js'));
const LeadsPage = lazy(() => import('../views/leads/LeadsPage.js'));
const CodesPage = lazy(() => import('../views/codes/CodesPage.js'));
const AmoRulesPage = lazy(() => import('../views/amo-rules-page/amo-rules-page.jsx'));
const AmoRuleEditorPage = lazy(() => import('../views/amo-rules-page/amo-rule-editor-page.jsx'));
const AmoRuleClientsPage = lazy(() => import('../views/amo-rules-page/amo-rule-clients-page.jsx'));
const AmoRuleErrorLogsPage = lazy(() => import('../views/amo-rules-page/amo-rule-error-logs-page.jsx'));
const AmoAnalyticsPage = lazy(() => import('../views/amo-rules-page/amo-analytics-page.jsx'));
const AmoCallsPage = lazy(() => import('../views/amo-rules-page/amo-calls-page.jsx'));
const AmoCallsSettingsPage = lazy(() => import('../views/amo-rules-page/amo-calls-settings-page.jsx'));
const AmoDealsSearchPage = lazy(() => import('../views/amo-rules-page/amo-deals-search-page.jsx'));
const AmoDedupPage = lazy(() => import('../views/amo-rules-page/amo-dedup/amo-dedup-page.jsx'));
const AnalyticsPage = lazy(() => import('../views/analytics/AnalyticsPage.js'));
const WidgetsListPage = lazy(() => import('../views/widgets/WidgetsListPage.js'));
const WidgetSettingsPage = lazy(() => import('../views/widgets/WidgetSettingsPage.js'));
const UsersPage = lazy(() => import('../views/users/UsersPage.js'));
const ShortLinksPage = lazy(() => import('../views/short-links/ShortLinksPage.js'));
const WidgetVisitorsPage = lazy(() => import('../views/widgets/WidgetVisitorsPage.js'));
const AllChatsPage = lazy(() => import('../views/chats/AllChatsPage.js'));
const SettingsPage = lazy(() => import('../views/settings/SettingsPage.js'));
const UtilitiesListPage = lazy(() => import('../views/utilities/UtilitiesListPage.js'));
const UtilitySettingsPage = lazy(() => import('../views/utilities/UtilitySettingsPage.js'));
const ScriptsPage = lazy(() => import('../views/scripts/ScriptsPage.js'));
const ProfilePage = lazy(() => import('../views/profile/ProfilePage.js'));
const AuditLogPage = lazy(() => import('../views/users/AuditLogPage.js'));


const ThemeRoutesFullLayout = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/',
      element: <Navigate to='/home' replace />,
    },
    { path: 'login', element: <Navigate to='/home' replace /> },
    { path: 'register', element: <Navigate to='/home' replace /> },
    { path: 'admin', element: <AdminOrdersPage /> },
    { path: 'promo', element: <PromoCheckPage /> },
    { path: 'home', element: <HomePage /> },
    { path: 'leads', element: <LeadsPage /> },
    { path: 'codes', element: <CodesPage /> },
    { path: 'amo/rules', element: <AmoRulesPage /> },
    { path: 'amo/rules/new', element: <AmoRuleEditorPage /> },
    { path: 'amo/rules/:id/edit', element: <AmoRuleEditorPage /> },
    { path: 'amo/rules/:id/clients', element: <AmoRuleClientsPage /> },
    { path: 'amo/rules/:id/logs', element: <AmoRuleErrorLogsPage /> },
    { path: 'amo/analytics', element: <AmoAnalyticsPage /> },
    { path: 'amo/calls', element: <AmoCallsPage /> },
    { path: 'amo/calls/settings', element: <AmoCallsSettingsPage /> },
    { path: 'amo/deals-search', element: <AmoDealsSearchPage /> },
    { path: 'amo/duplicates', element: <AmoDedupPage /> },
    { path: 'analytics', element: <AnalyticsPage /> },
    { path: 'widgets', element: <WidgetsListPage /> },
    { path: 'widgets/:id', element: <WidgetSettingsPage /> },
    { path: 'widgets/:id/visitors', element: <WidgetVisitorsPage /> },
    { path: 'users', element: <UsersPage /> },
    { path: 'users/audit', element: <AuditLogPage /> },
    { path: 'profile', element: <ProfilePage /> },
    { path: 'short-links', element: <ShortLinksPage /> },
    { path: 'utilities', element: <UtilitiesListPage /> },
    { path: 'utilities/:id', element: <UtilitySettingsPage /> },
    { path: 'chats', element: <AllChatsPage /> },
    { path: 'scripts', element: <ScriptsPage /> },
    { path: 'settings', element: <SettingsPage /> },
    { path: '*', element: <NotFoundPage /> },
  ],
};

export default ThemeRoutesFullLayout;
